import { render } from "./SiteAudience.vue?vue&type=template&id=325d3d5a&scoped=true"
import script from "./SiteAudience.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteAudience.vue?vue&type=script&setup=true&lang=js"

import "./SiteAudience.vue?vue&type=style&index=0&id=325d3d5a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-325d3d5a"],['__file',"src/views/SitesDash/manage/SiteAudience.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "325d3d5a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('325d3d5a', __exports__)) {
    api.reload('325d3d5a', __exports__)
  }
  
  module.hot.accept("./SiteAudience.vue?vue&type=template&id=325d3d5a&scoped=true", () => {
    api.rerender('325d3d5a', render)
  })

}


export default __exports__